// Shared metadata for the 8 EEMM tracks (Notion model v2).
// All UI components should import from here to stay in sync.
// Colours are mirrored in scripts/build-content.js (TRACK_COLORS).

export type DimensionId =
    | 'cognition'
    | 'affect'
    | 'attention'
    | 'self'
    | 'motivation'
    | 'behavior'
    | 'biophysiology'
    | 'social';

// Notion "Порядок" — the order the tracks are presented in.
export const DIMENSION_ORDER: DimensionId[] = [
    'cognition',
    'affect',
    'attention',
    'self',
    'motivation',
    'behavior',
    'biophysiology',
    'social',
];

export const DIMENSION_COLORS: Record<DimensionId, string> = {
    cognition: '#5B8FD6',
    affect: '#E66B5B',
    attention: '#4FA8C7',
    self: '#E9B44C',
    motivation: '#C77DBB',
    behavior: '#5EA68C',
    biophysiology: '#8FBF6A',
    social: '#9A7BCB',
};

export const DIMENSION_SHORT: Record<DimensionId, string> = {
    cognition: 'Cognition',
    affect: 'Emotions',
    attention: 'Attention',
    self: 'Self',
    motivation: 'Motivation',
    behavior: 'Behavior',
    biophysiology: 'Body',
    social: 'Connection',
};

// Returns hex color interpolated red→amber→green by score (0–100).
// 0 = critical red, 100 = healthy green.
export function zoneColor(value: number): string {
    const v = Math.max(0, Math.min(100, value));

    if (v <= 30) return '#22C55E';
    if (v <= 50) return '#84CC16';
    if (v <= 65) return '#EAB308';
    if (v <= 80) return '#F97316';
    return '#EF4444';
}

// Inverse: high value = good. Used for dimension scores (high = healthy).
export function dimensionZoneColor(percent: number): string {
    if (percent >= 70) return '#22C55E';
    if (percent >= 55) return '#84CC16';
    if (percent >= 41) return '#EAB308';
    if (percent >= 26) return '#F97316';
    return '#EF4444';
}

export function dimensionLevel(percent: number): {
    key: 'low' | 'medium' | 'high';
    label: string;
} {
    if (percent <= 40) return { key: 'low', label: 'Growth point' };
    if (percent <= 69) return { key: 'medium', label: 'Needs attention' };
    return { key: 'high', label: 'Strong' };
}

export function amplitudeBand(amplitudePercent: number): {
    key: 'low' | 'medium' | 'high' | 'critical';
    label: string;
} {
    if (amplitudePercent <= 30) return { key: 'low', label: 'Stable' };
    if (amplitudePercent <= 55) return { key: 'medium', label: 'Mild swing' };
    if (amplitudePercent <= 75) return { key: 'high', label: 'Strong swing' };
    return { key: 'critical', label: 'Critical swing' };
}
